export const model = {
    id: null,
    layout_id: null,
    points: '',
};